import { GzRuleAutomaticActionsWebComponent } from './component/GzRuleAutomaticActionsWebComponent';

export { GzRuleAutomaticActionsWebComponent };
